import React from "react"

/**
 * Inline icon set, ported verbatim from the prototype's `pages/Home/widgets.js`
 * plus the AppBar's moon/sign-out glyphs. All icons inherit `currentColor`.
 */
export type IconName =
    | "person"
    | "heart"
    | "file"
    | "copy"
    | "eye"
    | "play"
    | "mag"
    | "funnel"
    | "pulse"
    | "arrow"
    | "moon"
    | "signout"
    | "info"
    | "check"
    | "close"
    | "back"

type IconProps = {
    name: IconName
    className?: string
}

/**
 * @param props
 */
export default function Icon(props: IconProps) {
    const {name, className} = props;

    switch (name) {
        case "person":
            return (
              <svg className={className} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <circle cx="8" cy="5" r="2.6"/>
                  <path d="M2.8 13.5c.7-2.6 2.7-4 5.2-4s4.5 1.4 5.2 4"/>
              </svg>
            );
        case "heart":
            return (
              <svg className={className} viewBox="0 0 16 16" fill="currentColor">
                  <path d="M8 13.8S2.2 10.4 2.2 6.3C2.2 4.2 3.8 2.8 5.6 2.8c1 0 1.9.5 2.4 1.3.5-.8 1.4-1.3 2.4-1.3 1.8 0 3.4 1.4 3.4 3.5 0 4.1-5.8 7.5-5.8 7.5z"/>
              </svg>
            );
        case "file":
            return (
              <svg className={className} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
                  <rect x="2.5" y="3" width="11" height="10.5" rx="1.5"/>
                  <path d="M2.5 6.5h11M5.5 1.8v2.4M10.5 1.8v2.4"/>
              </svg>
            );
        case "copy":
            return (
              <svg className={className} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
                  <rect x="5.5" y="5.5" width="8" height="8" rx="1.5"/>
                  <path d="M10.5 5.5v-2a1 1 0 00-1-1h-6a1 1 0 00-1 1v6a1 1 0 001 1h2"/>
              </svg>
            );
        case "eye":
            return (
              <svg className={className} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
                  <path d="M1.5 8s2.4-4.3 6.5-4.3S14.5 8 14.5 8 12.1 12.3 8 12.3 1.5 8 1.5 8z"/>
                  <circle cx="8" cy="8" r="2"/>
              </svg>
            );
        case "play":
            return (
              <svg className={className} viewBox="0 0 16 16" fill="currentColor">
                  <path d="M5 3.5l8 4.5-8 4.5z"/>
              </svg>
            );
        case "mag":
            return (
              <svg className={className} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <circle cx="7" cy="7" r="4.5"/>
                  <path d="M10.5 10.5L14 14"/>
              </svg>
            );
        case "funnel":
            return (
              <svg className={className} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6"
                   strokeLinecap="round">
                  <path d="M2.5 4.5h11M4.75 8h6.5M6.75 11.5h2.5"/>
              </svg>
            );
        case "pulse":
            return (
              <svg className={className} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6"
                   strokeLinecap="round" strokeLinejoin="round">
                  <path d="M1.5 8h3l2-4.5L10 12l1.8-4H14.5"/>
              </svg>
            );
        case "arrow":
            return (
              <svg className={className} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.7"
                   strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 8h10M9 4l4 4-4 4"/>
              </svg>
            );
        case "moon":
            return (
              <svg className={className} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M13 9.5A5.5 5.5 0 1 1 6.5 3 4.5 4.5 0 0 0 13 9.5z"/>
              </svg>
            );
        case "signout":
            return (
              <svg className={className} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M6 2H3v12h3M10 5l3 3-3 3M13 8H6"/>
              </svg>
            );
        case "info":
            return (
              <svg className={className} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"
                   strokeLinecap="round">
                  <circle cx="8" cy="8" r="6.2"/>
                  <path d="M8 7.4v3.4M8 5.2v.1"/>
              </svg>
            );
        case "check":
            return (
              <svg className={className} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8"
                   strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 8.5l3.2 3.2L13 5"/>
              </svg>
            );
        case "close":
            return (
              <svg className={className} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6"
                   strokeLinecap="round">
                  <path d="M4 4l8 8M12 4l-8 8"/>
              </svg>
            );
        case "back":
            return (
              <svg className={className} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.7"
                   strokeLinecap="round" strokeLinejoin="round">
                  <path d="M13 8H3M7 4L3 8l4 4"/>
              </svg>
            );
        default:
            return null
    }
}
